import { useDataObjectTranslation } from "@app/common/hooks/useTranslation";
import { ThemeText } from "@app/componentLibrary/ui/text/Text/ThemeText";
import { IProperty } from "@app/property/types";
import { Flex } from "@ui";

interface IPropertyCardProps {
    property: IProperty;
    onClick?: (property: IProperty) => void;
}

export const PropertyCard = ({ property, onClick }: IPropertyCardProps) => {
    const description = useDataObjectTranslation(property.description);
    const imagePath = property.images[0]?.path || "https://placehold.co/600x400";

    return (
        <Flex flexDirection="col" alignItems="start" className="gap-y-3" data-testid={`property-card-${property.id}`}>
            <img
                alt={property.name}
                onClick={() => onClick && onClick(property)}
                src={imagePath}
                className="rounded-lg hover:shadow-lg h-52 lg:h-64 object-cover w-full cursor-pointer"
            />
            <ThemeText className="text-lg" data-testid="property-name">
                {property.name}
            </ThemeText>

            <div className="text-sm font-normal text-gray-500 leading-6" data-testid="property-description">
                {description}
            </div>
        </Flex>
    );
};
